import React from "react";

const Contact = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 text-center">
      <h2 className="text-3xl font-bold text-blue-600 mb-4">Contactez-nous</h2>
      <p className="text-gray-700 text-lg">
        Pour toute question, contactez-nous à{" "}
        <a href="mailto:contact@energesync.com" className="text-blue-600 hover:underline">
          contact@energesync.com
        </a>.
      </p>
    </div>
  );
};

export default Contact;
